module.exports = __webpack_public_path__ + "img/evaluate_thumbnail_005.5c750855.png";